import findDeep from "deepdash/findDeep";
function findActiveCategory(categoryTree, toFind, findBy = "url_path") {
  var _a, _b;
  const categories = categoryTree == null ? void 0 : categoryTree.children;
  return categories ? (_b = (_a = findDeep(categories, (value, key) => key === findBy && value === toFind)) == null ? void 0 : _a.parent) != null ? _b : null : null;
}
export {
  findActiveCategory
};
